module.exports = __webpack_public_path__ + "media/images/squared-4-8e55eb729d770f2bd14a8f9c9df928c5.png";